import { render, staticRenderFns } from "./supplier-admit-inquiry.vue?vue&type=template&id=5c954e62"
import script from "./supplier-admit-inquiry.vue?vue&type=script&lang=js"
export * from "./supplier-admit-inquiry.vue?vue&type=script&lang=js"
import style0 from "./supplier-admit-inquiry.vue?vue&type=style&index=0&id=5c954e62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports